import { axios } from './config';

export const updateFvpVastTagHistory = (siteId, vastDetails) => {
	return axios.put(`/cb/fvpVastHistory/updateDoc?siteId=${siteId}`, vastDetails);
};

export const getFvpVastTagHistory = (siteId) => {
	return axios.get(`/cb/fvpVastHistory?siteId=${siteId}`);
};
